import { useState, useEffect, useRef } from "react";

import "./DashboardVariable.css";
import TextArea from '/src/components/UI/TextField/TextArea';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
function DashboardInput({ data, activeError, postbackAction }) {
    const [actualHeight, setActualHeight] = useState("auto");

    const toast = useToastDispatchContext();
    const heightLine = 21;
    const [error, setError] = useState(false)
    const [typingTimer, setTypingTimer] = useState(null);
    const inputRef = useRef();

    const checkLines = (event) => {
        let text = event.target.value;

        modifyHeight(text);
        //////////////////
        if ( text != "" && (data.regex == null || data.regex.replace(/\s/g, '').length == 0)) { // no regex
            setError(false);
            saveData(text);
            return;
        }

        saveData(text,checkError(text));

    }

    const checkError = (val) => {
        let reg = data.regex
        if (reg == null) {
            reg=""
        }
        var regex = new RegExp(reg);
        let matched = regex.test(val);

        setError(!matched);
        activeError(!matched);
        return !matched
    }

    const modifyHeight = (text) => {
        const linesText = text.split('\n');
        var lines = linesText.length;
        const nbCaractersForOneRow = 85;
        linesText.forEach(line => {
            if (line.length > nbCaractersForOneRow){
                //console.log(line.length )
                lines+= Math.floor(line.length / nbCaractersForOneRow);
            }
        });
        if (lines > 10) {
            setActualHeight(10 * heightLine);
        }
        else {
    
            setActualHeight(lines * heightLine);
        }
        /* ANCIENNE VERSION : a supprimee quand sur de plus besoin
        if (lines >= 1 && lines <= 3) {
            if (lines == 1 && text.length > 60) {
                setActualHeight("auto");
            }
            else {
                setActualHeight(lines * heightLine);
            }
        }
        else if (lines < 3 && actualHeight > heightLine) {
            setActualHeight(lines * heightLine);
        }
            **/
    }
    const saveData = (text, err) => {
        clearTimeout(typingTimer);
        setTypingTimer(setTimeout(() => {
            if (err) {
                inputRef.current.value = data.value;
                setError(false)
                activeError(false);
                toast.success('Variable\'s value reinitialized', 'The value of the variable " ' + data.label + ' " has been reinitialized because the last one didn\'t match with the wished structure !',5000);

            }
            else {
                postbackAction(text);
            }
        }, 1500));
    }

    useEffect(() => {    // Update the document title using the browser API    document.title = `You clicked ${count} times`;  });
        modifyHeight(data.value)
    }, [data]);
    return (
        <div className="dashboard_text_area"key={data.id}>
            <TextArea ref={inputRef} defaultValue={data.value} style={{ height: actualHeight, borderColor: (error ? "var(--pink)" : "") }} onChange={(event) => checkLines(event)} onInput={(e) => { 'this.style.height = "";this.style.height = this.scrollHeight + "px"' }}></TextArea>
            {error == true && data.placeholder_format != null && data.placeholder_format.replace(/\s/g, '').length != 0 &&
                <div className="error_message">
                    {data.placeholder_format}
                </div>
            }

        </div>
    );
}

export default DashboardInput;